import {
  deleteRequest,
  getRequest,
  postRequest,
} from 'helpers/axios';

// ##### ##### ##### ##### #####   GET   ##### ##### ##### ##### ##### //
export const getBrandCollaborators = (businessId) => {
  return getRequest(`businesses/${businessId}/users`);
};

// ##### ##### ##### ##### #####   POST   ##### ##### ##### ##### ##### //
export const addBrandCollaborator = (businessId, userId) => {
  return postRequest(`businesses/${businessId}/users`, {
    user_id: userId,
  });
};

// ##### ##### ##### ##### #####   DELETE   ##### ##### ##### ##### ##### //
export const removeBrandCollaborator = (businessId, businessUserId) => {
  return deleteRequest(`businesses/${businessId}/users/${businessUserId}`);
};
